import type { ReactNode } from 'react'
import { Button, Typography } from 'shared/ui'
import { IconButton } from 'shared/ui/IconButton'
import styles from './styles.module.scss'

type IWidgetFooterProps = {
  step: number
  total: number
  onSkip: () => void
  onBack?: () => void
  action?: ReactNode
}

export const WidgetFooter = ({ step, total, onSkip, onBack, action }: IWidgetFooterProps) => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerLeft}>
        {step !== 1 && (
          <IconButton
            icon={'arrowLeft'}
            ariaLabel={'WidgetBack'}
            color={'secondary'}
            onClick={onBack}
          />
        )}
      </div>
      <Typography variant={'body-sm-regular'} ariaLabel={'WidgetStep'} color={'tertiary'}>
        {step} / {total}
      </Typography>
      <div className={styles.footerRight}>
        <Button contained={'secondary'} text={'Skip'} onClick={onSkip} />
        {action}
      </div>
    </div>
  )
}
